var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-layout',{attrs:{"wrap":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":""}},[_c('CCPaymentPage',{attrs:{"invoice":_vm.invoice}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }